import React from 'react'
import { Switch } from 'react-router-dom'
import LoadableRoute from '../components/features/share/loadable/loadableRoute'
import { PrivateRoute, PublicRoute } from './routePermission'

//Layout
const LayoutWithSidebar = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutWithSidebar'),
})
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank'),
})


//Features
//Auth
const LoginController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController'),
})

const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController'),
})
const HomeController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/homeController'),
})

// Display
const DisplayList = LoadableRoute({
    loader: () => import('../components/features/display/controllers/DisplayListController'),
})

const DisplayCreate = LoadableRoute({
    loader: () => import('../components/features/display/controllers/DisplayCreateController'),
})

const DisplayUpdate = LoadableRoute({
    loader: () => import('../components/features/display/controllers/DisplayUpdateController'),
})

const DisplayView = LoadableRoute({
    loader: () => import('../components/features/display/controllers/DisplayViewController'),
})

// Control Display Schedule
const ControleDisplayScheduleList = LoadableRoute({
    loader: () => import('../components/features/controlDisplaySchedule/controllers/listController'),
})

export default () => (
    <Switch>
        <PrivateRoute exact path='/' component={HomeController} layout={LayoutWithSidebar} />

        <PublicRoute exact path='/login' component={LoginController} layout={LayoutBlank} />

        <PrivateRoute exact path='/display/view/:id' component={DisplayView} layout={LayoutWithSidebar} />
        <PrivateRoute exact path='/display/edit/:id' component={DisplayUpdate} layout={LayoutWithSidebar} />
        <PrivateRoute exact path='/display/create' component={DisplayCreate} layout={LayoutWithSidebar} />
        <PrivateRoute exact path='/display' component={DisplayList} layout={LayoutWithSidebar} />

        
        
        <PrivateRoute exact path='/controldisplay' component={ControleDisplayScheduleList} layout={LayoutWithSidebar} />

        <PrivateRoute component={NotFoundController} layout={LayoutWithSidebar} />
    </Switch>
)


// WEBPACK FOOTER //
// ./src/app/routes/Routes.js